﻿window.chart_helper = function () {
    var Top = 30;
    var yAxisLegenda = 15;
    var xAxisLegenda = 30;
    var rotate = -65;
    var margin = { top: Top, right: 20, bottom: 120, left: 50 },
        width = 960 - margin.left - margin.right,
        height = 500 - margin.top - margin.bottom;

    function initChart(id, x, y, labels) {
        d3.select("#" + id + " svg").remove();
        var svg = d3.select("#" + id).append("svg")
            .attr('class', 'chart')
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom);
        svg.append("rect")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("fill", "white");
        svg = svg.append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        svg.append("rect")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("fill", "white");

        var xGrid = svg.append("g").call(d3.axisBottom().tickFormat("").tickSize(height).ticks(xticks(labels), "f").scale(x));
        var yGrid = svg.append("g").call(d3.axisLeft().tickFormat("").tickSize(-width).scale(y));

        xGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");
        yGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        var xOffset = labels.length === 1 ? width / 2 : 0;
        var xAxis = svg.append("g")
            .attr("transform", "translate(" + xOffset + "," + height + ")")
            .call(d3.axisBottom(x).ticks(xticks(labels), "f").tickFormat(function (d) {
                return labels[d];
            }));

        if (labels.length > 1)
            xAxis.selectAll("text")
                .style("text-anchor", "end")
                .attr("dx", "-.8em")
                .attr("dy", ".15em")
                .attr("transform", `rotate(${rotate})`);

        var yAxis = svg.append("g").call(d3.axisLeft(y).tickFormat(formatYAxis));

        var group = svg.append("g").attr("clip-path", "url(#clip)");

        var clip = svg.append("defs").append("clipPath")
            .attr("id", "clip")
            .append("rect")
            .attr("id", "clip-rect")
            .attr('stroke', 'red')
            .attr("width", width + 5)
            .attr("height", height)
            .attr("transform", "translate(-5,0)");

        var chart = { svg: svg, xAxis: xAxis, yAxis: yAxis, xGrid: xGrid, yGrid: yGrid, group: group, clip: clip };

        return chart;
    }
    
    
    const re = new RegExp(String.fromCharCode(160), "g");
    /**
     Для русской (ru) локали &nbsp;(160) является разделителем групп, мы должны удалить &nbsp;(160) так как svg его
     не поддерживает, new DOMParser().parseFromString('<svg><text>&nbsp;</text></svg>', "image/svg+xml" ) выбрасывает
     ошибку "This page contains the following errors:error on line 1 at column 18: Entity 'nbsp' not defined\nBelow is a rendering of the page up to the first error."
     DOMParser используется в canvg {@link download}
     * @param {number} d
     */
    function formatYAxis(d) {
        return d.toLocaleString("ru").replace(re, " ");
    }

    function xticks(xdata) {
        return xdata.length > 48 ? 48 : xdata.length;
    }

    function xscale(xdata) {
        return d3.scaleLinear().domain([0, xdata.length]).range([0, width]);
    }

    function yscale(data, maxfunc, minfunc) {
        var ymax = d3.max(data, maxfunc);
        var ymin = d3.min(data, minfunc);

        ymax = ymax + (ymax - ymin) * 0.1;
        ymin = ymin - (ymax - ymin) * 0.1;

        return d3.scaleLinear().domain([ymin, ymax]).range([height, 0]);
    }

    function updateChartOnClick(chart, newX, newY, labels, round) {

        chart.xAxis.call(d3.axisBottom(newX).ticks(xticks(labels), "f").tickFormat(function (d) { return labels[d]; }));
        chart.xAxis.selectAll("text")
            .style("text-anchor", "end")
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
            .attr("transform", `rotate(${rotate})`);

        chart.yAxis.call(d3.axisLeft(newY).tickFormat(formatYAxis));

        chart.yGrid.call(d3.axisLeft().tickFormat("").tickSize(-width).scale(newY));
        chart.yGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        chart.xGrid.call(d3.axisBottom().tickFormat("").tickSize(height).ticks(xticks(labels), "f").scale(newX));
        chart.xGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        var vLine = d3.line()
            .x(function (d, i) { return newX(i); })
            .y(function (d) { return newY(round ? d | 0 : d); });

        chart.svg.selectAll(".dataline").attr("d", function (d) { return vLine(d.values); });

        for (var i = 0; i < 10; i++)
            chart.svg.selectAll("#dots" + i).selectAll("circle")
                .attr("cx", function (d, i) { return newX(i); })
                .attr("cy", function (d) { return newY(round ? d | 0 : d); });
    }

    function updateChart(chart, x, y, labels, round, dataCount) {
        chart.svg.node().parentElement.setAttribute("width", width + margin.left + margin.right);
        chart.svg.node().parentElement.setAttribute("height", height + margin.top + margin.bottom);
        chart.svg.attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        
        // recover the new scale
        var newX = d3.event.transform ? d3.event.transform.rescaleX(x).range([0, width]) : x;
        var newY = d3.event.transform ? d3.event.transform.rescaleY(y).range([height, 0]) : y;

        // update axes with these new boundaries
        chart.xAxis.call(d3.axisBottom(newX).ticks(xticks(labels), "f").tickFormat(function (d) { return labels[d]; }));
        chart.xAxis.selectAll("text")
            .style("text-anchor", "end")
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
            .attr("transform", `rotate(${rotate})`);
        var xOffset = labels.length === 1 ? width / 2 : 0;
        chart.xAxis.attr("transform", "translate(" + xOffset + "," + height + ")");

        chart.yAxis.call(d3.axisLeft(newY).tickFormat(formatYAxis));

        chart.yGrid.call(d3.axisLeft().tickFormat("").tickSize(-width).scale(newY));
        chart.yGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        chart.xGrid.call(d3.axisBottom().tickFormat("").tickSize(height).ticks(xticks(labels), "f").scale(newX));
        chart.xGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        d3.select("#clip-rect").attr("width", width).attr("height", height);

        d3.select('#labelPeriod')
            .attr("x", width + margin.left + margin.right - 30)
            .attr("y", height + margin.top - 10);

        for (var i = 0; i < dataCount; i++) {
            var line = dotsReducer(newX, newY);
            chart.svg.select("#line" + i).attr("d", function (d) { return line.Line(d.values); });
            
            chart.svg.selectAll("#dots" + i).selectAll("circle")
                .attr("cx", function (d, i) { return line.Points[i][0].toFixed(); })
                .attr("cy", function (d, i) { return line.Points[i][1].toFixed(); });
            chart.svg.selectAll("#dots_" + i).selectAll("circle")
                .attr("opacity", function (d, i) { return i > 0 && line.Points[i][0].toFixed() == line.Points[i - 1][0].toFixed() && line.Points[i][1].toFixed() == line.Points[i - 1][1].toFixed() ? 0 : 1; })
                .attr("cx", function (d, i) { return line.Points[i][0].toFixed(); })
                .attr("cy", function (d, i) { return line.Points[i][1].toFixed(); });
            chart.svg.selectAll("#dots_empty_" + i).selectAll("circle")
                .attr("cx", function (d, i) { return line.Points[i][0].toFixed(); })
                .attr("cy", function (d, i) { return line.Points[i][1].toFixed(); })
                .attr("xlabel", function (d, i) { return labels[line.Points[i][2]] + "\nТП удалена или не имеет формул расчета"; });
            chart.svg.selectAll("#dots_nc_" + i).selectAll("circle")
                .attr("cx", function (d, i) { return line.Points[i][0].toFixed(); })
                .attr("cy", function (d, i) { return line.Points[i][1].toFixed(); })
                .attr("xlabel", function (d, i) { return labels[line.Points[i][2]] + "\nНекоммерческий статус"; });
            chart.svg.selectAll("#dots_ic_" + i).selectAll("circle")
                .attr("cx", function (d, i) { return line.Points[i][0].toFixed(); })
                .attr("cy", function (d, i) { return line.Points[i][1].toFixed(); })
                .attr("xlabel", function (d, i) { return labels[line.Points[i][2]] + "\nНет данных"; });
        }

        chart.svg.selectAll("#zeroLine")
            .attr("x1", newX(0))
            .attr("y1", newY(0))
            .attr("x2", newX(labels.length - 1))
            .attr("y2", newY(0));
    }

    function dotsReducer(x, y) {
        var LastIndex = 0;
        var PrevXPos = 0;
        var PrevYValue = 0;
        var Delta = 15;
        const xDelta = 10;

        var points = [];
        var cxy_x = x;
        var cxy_y = y;

        var cx = function (d, i) {
            var xi = cxy_x(i);
            if (i == 0) {
                PrevXPos = xi;
            }
            if (xi - PrevXPos < xDelta) {
                var delta = Math.abs(cxy_y(d) - PrevYValue);
                if (delta < Delta) {
                    xi = PrevXPos;
                }
                else {
                    LastIndex = i;
                }
            }
            else
                LastIndex = i;
            PrevXPos = xi;
            return xi;
        };
        var cy = function (d, i) {
            var yi = cxy_y(d);
            if (i == 0) {
                PrevYValue = yi;
            }
            else if (LastIndex < i)
                yi = PrevYValue;

            PrevYValue = yi;
            points.push([PrevXPos, PrevYValue, LastIndex]);
            return yi;
        };

        var vLine = d3.line()
            .x(cx)
            .y(cy);

        return { Points: points, Line: vLine };
    }

    var instance = {

        selectCheckbox: function(id) {
            var checkbox = document.getElementById(id);
            if (checkbox.getAttribute('checkbox') === "true") {
                checkbox.setAttribute('checkbox', "false");
                checkbox.textContent = chart_helper.getUnCheckboxUnchecked();
            } else {
                checkbox.setAttribute('checkbox', "true");
                checkbox.textContent = chart_helper.getCheckboxChecked();
            }
        },

        getRandomColors: function (count) {
            var result = Array(count);
            for (var j = 0; j < count; j++) {
                result[j] = chart_helper.getColor();
            }
            return result;
        },

        getColor: function () {
            var letters = '0123456789ABCDEF';
            var color = '#';
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },

        getCheckboxChecked: function() {
            return "\u2611";
        },

        getUnCheckboxUnchecked: function () {
            return "\u2610";
        },

        addButtonReduceZoom: function (zoom, svg) {
            var buttons = document.getElementById("chartButtons");
            var btnReduceZoom = document.createElement("button");
            btnReduceZoom.innerText = "-";
            btnReduceZoom.style.cssText = "margin:2px;width:30px;font-weight:bold";
            btnReduceZoom.classList.add("btn");
            btnReduceZoom.classList.add("btn-primary");            
            btnReduceZoom.title = "Уменьшить";
            btnReduceZoom.onclick = function () { zoom.scaleBy(svg, 0.9); return false; };
            buttons.appendChild(btnReduceZoom);
        },

        addButtonIncreaseZoom: function (zoom, svg) {
            var buttons = document.getElementById("chartButtons");
            var btnIncreaseZoom = document.createElement("button");
            btnIncreaseZoom.innerText = "+";
            btnIncreaseZoom.style.cssText = "margin:2px;width:30px";
            btnIncreaseZoom.classList.add("btn");
            btnIncreaseZoom.classList.add("btn-primary");            
            btnIncreaseZoom.title = "Увеличить";
            btnIncreaseZoom.onclick = function () { zoom.scaleBy(svg, 1.111); return false; };
            buttons.appendChild(btnIncreaseZoom);
        },

        addButtonFullScreen: function (chartDiv) {
            var buttons = document.getElementById("chartButtons");
            var btnFullScreen = document.createElement("button");
            btnFullScreen.innerText = "⛶";
            btnFullScreen.style.cssText = "float:right; margin: 2px; width: 30px; font-size:20pt;padding:0px";
            btnFullScreen.classList.add("btn");
            btnFullScreen.classList.add("btn-primary");
            btnFullScreen.title = "Во весь экран";
            btnFullScreen.onclick = function (event) {
                if (btnFullScreen.innerText == "⛶") {
                    chartDiv.style.position = "absolute";
                    chartDiv.style.top = "0px";
                    chartDiv.style.left = "0px";
                    chartDiv.style.width = "100%";
                    chartDiv.style.zIndex = 10;
                    btnFullScreen.title = "Вернуться";
                    btnFullScreen.innerText = "✖";
                }
                else {
                    chartDiv.style.position = "relative";
                    chartDiv.style.top = null;
                    chartDiv.style.left = null;
                    chartDiv.style.width = null;
                    chartDiv.style.zIndex = null;
                    btnFullScreen.title = "Во весь экран";
                    btnFullScreen.innerText = "⛶";
                }
                return false;
            };
            window.$('.chart').parent().prepend(btnFullScreen);
        },

        addButtonResetZoom: function (zoom, svg) {
            var buttons = document.getElementById("chartButtons");
            var btnResetZoom = document.createElement("button");
            btnResetZoom.id = "btnResetZoom";
            btnResetZoom.innerHTML = '100%';
            btnResetZoom.style.cssText = "margin:2px; width:50px";
            btnResetZoom.classList.add("btn");
            btnResetZoom.classList.add("btn-primary");
            btnResetZoom.title = "Сброс масштаба";
            btnResetZoom.onclick = function () {
                zoom.scaleTo(svg.transition().duration(1000), 1);
                return false;
            };
            buttons.appendChild(btnResetZoom);

            var spanScale = document.createElement("span");
            spanScale.id = "spanScale";
            spanScale.innerHTML = 'Масштаб: 100%';
            spanScale.style.cssText = "margin-top:5px; padding: 6px; width:120px";
            buttons.appendChild(spanScale);
        },
                
        getChartButtons: function () {
            var buttons = document.getElementById("chartButtons");
            if (!buttons) {
                buttons = document.createElement("span");
                buttons.id = "chartButtons";
                buttons.style.cssText = "float:left";
                window.$('.chart').parent().prepend(buttons);
            }
            return buttons;
        },

        addButtonSave: function (title) {
            var buttons = this.getChartButtons();
            var btnSave = document.createElement("button");
            btnSave.innerHTML = '<i class="icon icon-ic_save"><svg class="svgicon-ic_save"><use xlink:href="/data/icons/svg#icon-ic_save"></use></svg></i> Сохранить в JPG';
            btnSave.style.cssText = "margin:2px;width:140px";
            btnSave.classList.add("btn");
            btnSave.classList.add("btn-primary");            
            btnSave.onclick = function() {
                chart_helper.download(title + '.jpg');
                return false;
            };
            buttons.appendChild(btnSave);
        },

        download: function (fileName) {
            var svg = document.querySelector('.chart');
            var canvas = document.createElement('canvas');
            canvas.height = svg.getAttribute('height');
            canvas.width = svg.getAttribute('width');
            var context = canvas.getContext("2d");
            var outerHtml = $('<div>').append($(svg).clone()).html();
            var c1 = canvg.Canvg.fromString(context, outerHtml.trim());
            c1.start();
            var dataUrl = canvas.toDataURL('image/jpeg');
            if (svg.outerHTML) {
                var a = document.createElement("a");
                a.textContent = "save";
                a.download = fileName;
                a.href = dataUrl;
                a.click();
            } else {
                var blob = chart_helper.dataUrItoBlob(dataUrl);
                window.navigator.msSaveOrOpenBlob(blob, fileName);
            }
        },

        dataUrItoBlob: function (dataUri) {
            var binary = atob(dataUri.split(',')[1]);
            var array = [];
            for (var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], { type: 'image/jpeg' });
        },

        toggleClassAll: function (args) {
            var root = args.root ? args.root : document;
            var els = root.querySelectorAll(args.itemsSelector);
            var senders = root.querySelectorAll(args.itemsSelectorSenders);

            for (var i = 0; i < els.length; i++) {
                if (args.senderState == 1) {
                    els[i].classList.remove(args.clsName);
                }
                else
                    els[i].classList.add(args.clsName);
            }

            for (var i = 0; i < senders.length; i++) {
                if (args.senderState == 1) {
                    senders[i].classList.remove(args.senderClsName);
                }
                else
                    senders[i].classList.add(args.senderClsName);
            }
            
        },

        onClickChekbox: function (nameCheckbox, nameHidden, rowid, backgroundColor, idHideShow) {
            var checkbox = document.querySelector('[name="' + nameCheckbox + '"]');
            var hidden = document.querySelector('[name="' + nameHidden + '"]');
            var tr = document.querySelector('[data-rowid="' + rowid + '"]');

            if (idHideShow != null && idHideShow != "") {
                var hsCheckbox = document.querySelectorAll('[data-type="' + 'c' + idHideShow + '"]');
                var hsHidden = document.querySelectorAll('[data-type="' + 'h' + idHideShow + '"]');
                var hsTr = document.querySelectorAll('[data-type="' + idHideShow + '"]');
                for (var i = 0; i < hsTr.length; i++) {
                    var item = hsTr[i];
                    if (tr.id == item.id)
                        continue;
                    item.style.backgroundColor = "";
                }
                for (var i = 0; i < hsHidden.length; i++) {
                    var item = hsHidden[i];
                    if (hidden.name == item.name)
                        continue;
                    item.value = "False";
                }
                for (var i = 0; i < hsCheckbox.length; i++) {
                    var item = hsCheckbox[i];
                    if (checkbox.name == item.name)
                        continue;
                    item.checked = false;
                }
            }

            if (checkbox.checked) {
                hidden.value = "True";
                tr.style.backgroundColor = backgroundColor;
            }
            else {
                hidden.value = "False";
                tr.style.backgroundColor = "";
            }
        },
        renderCheckMark: function (gr, id, color) {
            gr.append('path')
                .attr('d', "M25.333 6.66699V25.334H6.66602V6.66699H25.333Z")
                .attr("fill", "white")
                .attr("transform", "scale(0.667)");
            gr.append('path')
                .attr('d', "M13.333 22.667L6.66602 16L8.54602 14.107L13.333 18.894L23.453 8.774L25.333 10.667L13.333 22.667ZM25.333 4H6.66602C5.18602 4 3.99902 5.187 3.99902 6.667V25.334C3.99902 26.807 5.19302 28.001 6.66602 28.001H25.333C26.806 28.001 28 26.807 28 25.334V6.667C28 5.187 26.8 4 25.333 4V4Z")
                .attr("fill", color)
                .attr("transform", "scale(0.667)");
            gr.append('path')
                .attr('d', "M25.333 6.66699V25.334H6.66602V6.66699H25.333Z")
                .attr("fill", "white")
                .attr("transform", "scale(0.667)")
                .attr("opacity", 0)
                .attr("id", id);
        },

        getWidth: function (text, fontSize, fontFace) {
            var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d');
            context.font = fontSize + 'px ' + fontFace;
            return context.measureText(text).width;
        },

        renderChart: function (args) {
            var data = window.$(`#${args.idData}`).val();
            
            if (data == undefined || data === "" || data == null)
                return;

            var dataArray = JSON.parse(data);
            if (dataArray.length == 0)
                return;

            var titles = new Array(dataArray.length);
            var sec = new Array(dataArray.length);
            var show_ic = true;
            var show_nc = true;
            var show_empty = true;
            var xdata = new Array(dataArray[0].Data.length);
            var ydata = new Array(dataArray.length);
            var data_nc = new Array(dataArray.length);
            var data_ic = new Array(dataArray.length);
            var data_empty = new Array(dataArray.length);

            for (var j = 0; j < dataArray.length; j++) {
                titles[j] = dataArray[j].Title;
                sec[j] = dataArray[j].Visible ?? true;
                var dictionary = dataArray[j].Data;
                var dictionaryNC = dataArray[j].StatusNonCommercial;
                var dictionaryIC = dataArray[j].StatusIncomplete;
                var dictionaryEmpty = dataArray[j].StatusEmpty;
                var jj = 0;
                ydata[j] = new Array(dataArray[j].Data.length);
                if (dictionaryNC)
                    data_nc[j] = new Array(dataArray[j].Data.length);
                if (dictionaryIC)
                    data_ic[j] = new Array(dataArray[j].Data.length);
                if (dictionaryEmpty)
                    data_empty[j] = new Array(dataArray[j].Data.length);
                for (var key in dictionary) {
                    if (Object.prototype.hasOwnProperty.call(dictionary, key)) {
                        xdata[jj] = key;
                        ydata[j][jj] = dictionary[key];
                        if (dictionaryNC)
                            data_nc[j][jj] = dictionaryNC[key];
                        if (dictionaryIC)
                            data_ic[j][jj] = dictionaryIC[key];
                        if (dictionaryEmpty)
                            data_empty[j][jj] = dictionaryEmpty[key];
                        jj++;
                    }
                }
            }
            var maxvalue = d3.max(ydata, function (array) { return d3.max(array); });
            margin.left = this.getWidth(formatYAxis(maxvalue), 13, 'Roboto') + 10;

            //TODO: Можно вынести в настройки
            width = window.$(`#${args.idChart}`).width() - 30 - margin.left - margin.right;
            if (width < 0)
                width = 400;
            height = width / 2.5;
            if (args.autoResize)
                height = window.$(`#${args.idChart}`).height() - 50 - margin.top - margin.bottom;
            if (height < 0)
                height = 300;

            // цвета разделов
            var colors = args.colors ?? chart_helper.getRandomColors(titles.length);

            if (args.rotate)
                rotate = args.rotate;

            //num - номер раздела, isScale: участвует в расчете по y
            //time - шкала времени, series - массив данных
            var data = { num: -1, isScaleY: false, time: xdata, series: [] };

            this.loadDataSeries(sec, data, xdata, ydata, titles);

            var checkMarkNoData = data_ic && data_ic.length > 0 && data_ic[0] && data_ic[0].length > 0 && data_ic[0][0] != undefined;
            var checkMarkNonCommercial = data_nc && data_nc.length > 0 && data_nc[0] && data_nc[0].length > 0 && data_nc[0][0] != undefined;
            var checkMarkEmpty = data_empty && data_empty.findIndex(arr => arr.findIndex(a2 => a2) >= 0) >= 0;
            var yAxisShift = (checkMarkNoData || checkMarkNonCommercial) ? 1.5 : 0;

            margin.top = Top;
            let legendaHeight = titles.length * yAxisLegenda;
            
            if (checkMarkNoData || checkMarkNonCommercial || checkMarkEmpty)
                margin.top = margin.top + 30
                    
            var labels = xdata;

            var maxfunc = function (d) {
                if (d.isScale)
                    return Math.max.apply(null, d.values);
            };
            var minfunc = function (d) {
                if (d.isScale)
                    return Math.min.apply(null, d.values);
            };

            var x = xscale(xdata);
            var y = yscale(data.series, maxfunc, minfunc);

            var chart = initChart(args.idChart, x, y, labels);

            
            //var vLine = d3.line()
            //    .x(function (d, i) { return x(i); })
            //    .y(function (d) { return y(d); });

            var measure = args.measure ?? "кВт";

            var svg = d3.select("svg.chart");
            chart.group.append("line")
                .attr("id", "zeroLine")
                .attr("stroke", "#0DF")
                .attr("stroke-width", 1.5)
                .attr("x1", x(0))
                .attr("y1", y(0))
                .attr("x2", x(xdata.length - 1))
                .attr("y2", y(0));

            var gLegend = svg.append("g").attr("transform", "translate(20," + (checkMarkNoData || checkMarkNonCommercial || checkMarkEmpty ? "35" : "15") + ")").style("cursor", "pointer");
            gLegend.append("title").text("Показать/скрыть перечень каналов (легенду)");
            gLegend.append("rect")
                .attr("rx", "4")
                .attr("ry", "4")
                .attr("x", "-4")
                .attr("y", "-12")
                .attr("width", "16")
                .attr("height", "16")
                .attr("fill", "#eee");
            gLegend.append('path')
                .attr('d', "M3 -10l-1 1 5 5 -5 5 1 1 6 -6z")
                .attr('id', "gLegendCheck");
            gLegend.append("text")
                .attr("x", 15)
                .attr("y", 0)
                .style("font-size", "14px")
                .style("font-weight", "normal")
                .style("text-decoration", "underline")
                .style("fill", "blue")
                .text("Перечень каналов (легенда)");
            var gLegendContent = svg.append("g").attr("active", "0").style("opacity", 0).attr("transform", "translate(" + margin.left.toString() + "," + (13 + yAxisLegenda).toString() + ")");
            gLegend.on("click", function () {
                var newOpacity = gLegendContent.attr("active") == '1' ? 0 : 1;
                gLegendContent.style("opacity", newOpacity);
                gLegendContent.attr("active", newOpacity);
                if (newOpacity == 0)
                    margin.top = margin.top - legendaHeight;
                else
                    margin.top = margin.top + legendaHeight;

                if (args.autoResize) {
                    height = chartDiv.offsetHeight - 50 - margin.top - margin.bottom;
                    if (height < 300)
                        height = 300;
                }
                zoom.scaleBy(svg, 1);
                d3.select('#measureLabel').attr("y", margin.top + 20);
                if (newOpacity == 1)
                    d3.select('#gLegendCheck').transition().attr("transform", "translate(0,-10) rotate(90)");
                else
                    d3.select('#gLegendCheck').transition().attr("transform", "translate(0,0) rotate(0)");
            });


            for (var i = 0; i < sec.length; i++) {
                var line = dotsReducer(x, y);

                chart.group.append("path")
                    .attr("id", "line" + i)
                    .attr("active", "1")
                    .attr("fill", "none")
                    .attr("stroke", colors[i])
                    .attr('class', 'dataline')
                    .data([data.series[i]])
                    .attr("d", function (d) {
                        return line.Line(d.values);
                    });
                chart.group.append("g")
                    .attr("id", "dots" + i)
                    .attr('class', 'dots')
                    .attr("stroke", colors[i])
                    .attr("fill", colors[i])
                    .attr("stroke-width", 1)
                    .selectAll("circle")
                    .data(data.series[i].values)
                    .join("circle")
                    .attr("cx", function (d, i) { return line.Points[i][0].toFixed(); })
                    .attr("cy", function (d, i) { return line.Points[i][1].toFixed(); })
                    .attr("xlabel", function (d, i) { return labels[line.Points[i][2]]; })
                    .attr("name", titles[i])
                    //.attr("opacity", "0")
                    .attr("r", 2);
                chart.group.append("g")
                    .attr("id", "dots_" + i)
                    .attr('class', 'dots')
                    .attr("stroke", "#222")
                    .attr("fill", "transparent")
                    .attr("stroke-width", 0.7)
                    .selectAll("circle")
                    .data(data.series[i].values)
                    .join("circle")
                    .attr("cx", function (d, i) { return line.Points[i][0].toFixed(); })
                    .attr("cy", function (d, i) { return line.Points[i][1].toFixed(); })
                    .attr("xlabel", function (d, i) { return labels[line.Points[i][2]]; })
                    .attr("name", titles[i])
                    .attr("r", 2.5);
                if (data_empty && data_empty[i] && data_empty[i].length > 0)
                    chart.group.append("g")
                        .attr("id", "dots_empty_" + i)
                        .attr('class', 'dots')
                        .attr("stroke", "darkgray")
                        .attr("stroke-width", 2)
                        .attr("fill", "transparent")
                        .selectAll("circle")
                        .data(data.series[i].values)
                        .join("circle")
                        .attr("cx", function (d, i) { return line.Points[i][0].toFixed(); })
                        .attr("cy", function (d, i) { return line.Points[i][1].toFixed(); })
                        .attr("xlabel", function (d, i) { return labels[line.Points[i][2]] + "\nТП удалена или не имеет формул расчета"; })
                        .attr("name", titles[i])
                        .attr("visibility", function (d, i1) { return data_empty[i][i1] ? "visible" : "hidden"; })
                        .attr("r", 4);
                if (data_nc && data_nc[i] && data_nc[i].length > 0 && data_nc[i][0] != undefined)
                    chart.group.append("g")
                        .attr("id", "dots_nc_" + i)
                        .attr('class', 'dots')
                        .attr("stroke", "#FFD800")
                        .attr("stroke-width", 1)
                        .attr("fill", "transparent")
                        .selectAll("circle")
                        .data(data.series[i].values)
                        .join("circle")
                        .attr("cx", function (d, i) { return line.Points[i][0].toFixed(); })
                        .attr("cy", function (d, i) { return line.Points[i][1].toFixed(); })
                        .attr("xlabel", function (d, i) { return labels[line.Points[i][2]] + "\nНекоммерческий статус"; })
                        .attr("name", titles[i])
                        .attr("visibility", function (d, i1) { return data_nc[i][i1] ? "visible" : "hidden"; })
                        .attr("r", 5);
                if (data_ic && data_ic[i] && data_ic[i].length > 0 && data_ic[i][0] != undefined)
                    chart.group.append("g")
                        .attr("id", "dots_ic_" + i)
                        .attr('class', 'dots')
                        .attr("stroke", "red")
                        .attr("stroke-width", 1)
                        .attr("fill", "transparent")
                        .selectAll("circle")
                        .data(data.series[i].values)
                        .join("circle")
                        .attr("cx", function (d, i) { return line.Points[i][0].toFixed(); })
                        .attr("cy", function (d, i) { return line.Points[i][1].toFixed(); })
                        .attr("xlabel", function (d, i) { return labels[line.Points[i][2]] + "\nНет данных"; })
                        .attr("name", titles[i])
                        .attr("visibility", function (d, i1) { return data_ic[i][i1] && !data_nc[i][i1] ? "visible" : "hidden"; })
                        .attr("r", 5);

                var onLabelClick = function () {
                    if (sec.length > 1) {
                        var n = d3.event.target.getAttribute('line');
                        var line = d3.select("#line" + n);
                        var newOpacity = line.attr("active") == '1' ? 0 : 1;
                        var isView = newOpacity == 0 ? false : true;
                        sec[n] = isView;
                        line.style("opacity", newOpacity);
                        line.attr("active", newOpacity);
                        d3.select("#text" + n).style('fill', newOpacity == 0 ? '#ccc' : colors[n]);

                        if (!btnPoints.classList.contains("btnchecked"))
                            newOpacity = 0;
                        d3.select("#dots" + n).style("opacity", newOpacity);
                        d3.select("#dots_" + n).style("opacity", newOpacity);
                        d3.select("#dots_empty_" + n).style("opacity", newOpacity);
                        d3.select("#dots_nc_" + n).style("opacity", newOpacity);
                        d3.select("#dots_ic_" + n).style("opacity", newOpacity);

                        chart_helper.selectCheckbox("unicode_checkbox_" + n);

                        for (var p = 0; p < data.series.length; p++) {
                            if (data.series[p].num == n)
                                data.series[p].isScale = isView;
                        }
                        x = xscale(xdata);
                        y = yscale(data.series, maxfunc, minfunc);

                        updateChart(chart, x, y, labels, true, sec.length);
                    }
                };

                gLegendContent.append("text")
                    .attr("id", "unicode_checkbox_" + i)
                    .attr("y", 5 + ((i + yAxisShift) * yAxisLegenda))
                    .attr("line", i)
                    .attr("checkbox", true)
                    .style("cursor", "pointer")
                    .style("font-size", "11pt")
                    .text(chart_helper.getCheckboxChecked())
                    .on("click", onLabelClick);

                gLegendContent.append("text")
                    .attr("id", "text" + i)
                    .attr("x", 15)
                    .attr("y", 5 + ((i + yAxisShift) * yAxisLegenda))
                    .attr("line", i)
                    .style("fill", colors[i])
                    .style("font-size", "12px")
                    .style("font-weight", "normal")
                    .style("cursor", "pointer")
                    .text(titles[i])
                    .on("click", onLabelClick);
            }

            var display_empty = function (dots_empty_num) {
                var dots_empty = d3.select("#dots_empty_" + dots_empty_num);
                if (sec[dots_empty_num] && btnPoints.classList.contains("btnchecked") && show_empty) {
                    dots_empty.style("opacity", "1");
                }
                if (!sec[dots_empty_num] || !btnPoints.classList.contains("btnchecked") || !show_empty) {
                    dots_empty.style("opacity", "0");
                }
            }

            var display_ic = function (dots_ic_num) {
                var dots_ic = d3.select("#dots_ic_" + dots_ic_num);
                if (sec[dots_ic_num] && btnPoints.classList.contains("btnchecked") && show_ic) {
                    dots_ic.style("opacity", "1");
                }
                if (!sec[dots_ic_num] || !btnPoints.classList.contains("btnchecked") || !show_ic) {
                    dots_ic.style("opacity", "0");
                }
            }

            var display_nc = function (dots_nc_num) {
                var dots_nc = d3.select("#dots_nc_" + dots_nc_num);
                if (sec[dots_nc_num] && btnPoints.classList.contains("btnchecked") && show_nc) {
                    dots_nc.style("opacity", "1");
                }
                if (!sec[dots_nc_num] || !btnPoints.classList.contains("btnchecked") || !show_nc) {
                    dots_nc.style("opacity", "0");
                }
            }

            svg.append("text")
                .attr("x", margin.left + 10)
                .attr("y", margin.top + 20)
                .style("font-size", "11px")
                .attr("id", "measureLabel")
                .text(measure);

            svg.append("text")
                .attr("id", "labelPeriod")
                .attr("x", width + margin.left + margin.right - 30)
                .attr("y", height + margin.top - 10)
                .attr("text-anchor", "end")
                .style("font-size", "11px")
                .text("Период");            
            
            if (checkMarkNoData) {               
                var g = svg.append("g").attr("transform", "translate(0,0)").style("cursor", "pointer");
                this.renderCheckMark(g, "checkMarkNoData", "#3C90F2");
                g.append("circle")
                    .attr("cx", 33)
                    .attr("cy", 12)
                    .attr("width", 6)
                    .attr("height", 6)
                    .attr("stroke", "red")
                    .attr("stroke-width", 2)
                    .attr("fill", "transparent")
                    .attr("r", "5");
                g.append("text")
                    .attr("x", 45)
                    .attr("y", 16)
                    .style("font-size", "12px")
                    .style("font-weight", "normal")
                    .text("Нет данных");
                g.on("click", function () {
                    show_ic = !show_ic;
                    for (var n = 0; n < sec.length; n++) {
                        var cm = d3.select("#checkMarkNoData");
                        cm.style("opacity", show_ic ? 0 : 1);
                        display_ic(n);
                    }
                });
            }
            if (checkMarkNonCommercial) {
                var translate = checkMarkNoData ? "translate(125,0)" : "translate(0,0)";
                var g = svg.append("g").attr("transform", translate).style("cursor", "pointer");
                this.renderCheckMark(g, "checkMarkNonCommercial", "#3C90F2");
                g.append("circle")
                    .attr("cx", 33)
                    .attr("cy", 12)
                    .attr("width", 6)
                    .attr("height", 6)
                    .attr("stroke", "#FFD800")
                    .attr("stroke-width", 2)
                    .attr("fill", "transparent")
                    .attr("r", "5");
                g.append("text")
                    .attr("x", 45)
                    .attr("y", 16)
                    .style("font-size", "12px")
                    .style("font-weight", "normal")
                    .text("Некоммерческий статус");
                g.on("click", function () {
                    show_nc = !show_nc;
                    for (var n = 0; n < sec.length; n++) {
                        var cm = d3.select("#checkMarkNonCommercial");
                        cm.style("opacity", show_nc ? 0 : 1);
                        display_nc(n);
                    }
                });
            }
            if (checkMarkEmpty) {
                var translate = checkMarkNonCommercial ? "translate(320,0)" : "translate(0,0)";
                var g = svg.append("g").attr("transform", translate).style("cursor", "pointer");
                this.renderCheckMark(g, "checkMarkEmpty", "#3C90F2");
                g.append("circle")
                    .attr("cx", 33)
                    .attr("cy", 12)
                    .attr("width", 6)
                    .attr("height", 6)
                    .attr("stroke", "#CCC")
                    .attr("stroke-width", 2)
                    .attr("fill", "transparent")
                    .attr("r", "5");
                g.append("text")
                    .attr("x", 45)
                    .attr("y", 16)
                    .style("font-size", "12px")
                    .style("font-weight", "normal")
                    .text("ТП Удалена или не имеет формул расчета");
                g.on("click", function () {
                    show_empty = !show_empty;
                    for (var n = 0; n < sec.length; n++) {
                        var cm = d3.select("#checkMarkEmpty");
                        cm.style("opacity", show_empty ? 0 : 1);
                        display_empty(n);
                    }
                });
            }
            // Set the zoom and Pan features: how much you can zoom, on which part, and what to do when there is a zoom
            var zoom = d3.zoom()
                .scaleExtent([.8, 15])
                .extent([[0, 0], [width, height]])
                .translateExtent([[0, 0], [width, height]])
                .filter(() => {
                    return d3.event.shiftKey;
                })
                .on("zoom", function () {
                    var k = d3.event.transform.k * 100;
                    var spanScale = document.getElementById("spanScale");
                    if (spanScale)
                        spanScale.innerHTML = "Масштаб: " + k.toFixed(0).toString() + "%";
                    updateChart(chart, x, y, labels, true, sec.length);
                });

            svg.call(zoom);

            if (args.autoResize) {
                var chartDiv = document.getElementById(args.idChart);
                var lastWidth = chartDiv.offsetWidth;
                var lastHeight = chartDiv.offsetHeight;
                var lastTop = margin.top;
                svg.node().style = "position:absolute;left:5px;top:40px";

                var action = function () {
                    var currentWidth = chartDiv.offsetWidth;
                    var currentHeight = chartDiv.offsetHeight;
                    if (currentWidth == 0)
                        return;
                    if (lastWidth !== currentWidth || lastHeight !== currentHeight || lastTop != margin.top) {
                        lastWidth = currentWidth;
                        lastHeight = currentHeight;
                        lastTop = margin.top;
                        width = lastWidth - 30 - margin.left - margin.right;
                        height = lastHeight - 50 - margin.top - margin.bottom;
                        if (width < 0)
                            width = 400;
                        if (height < 300)
                            height = 300;
                        //zoom.extent([[0, 0], [width, height]]);
                        //zoom.translateExtent([[0, 0], [width, height]]);
                        //svg.call(zoom);
                        zoom.scaleBy(svg, 1);
                    }
                };
                setInterval(action, 100);
            }


            var callout = function (g, value) {
                if (!value) return g.style("display", "none");

                g
                    .style("display", null)
                    .style("pointer-events", "none")
                    .style("font", "10px sans-serif");

                const path = g.selectAll("path")
                    .data([null])
                    .join("path")
                    .attr("fill", "white")
                    .attr("stroke", "black");

                const text = g.selectAll("text")
                    .data([null])
                    .join("text")
                    .call(function (text) {
                        text
                            .selectAll("tspan")
                            .data((value + "").split(/\n/))
                            .join("tspan")
                            .attr("x", 0)
                            .attr("y", function (d, i) { return (i * 1.1).toString() + 'em'; })
                            .style("font-weight", function (_, i) { return i ? null : "bold"; })
                            .text(function (d) { return d; });
                    });

                var bb = text.node().getBBox();
                g.attr("w", bb.width / 2);

                text.attr("transform", 'translate(' + (-bb.width / 2).toString() + ',' + (15 - bb.y).toString() + ')');
                path.attr("d", 'M' + (-bb.width / 2 - 10).toString() + ',5H-5l5,-5l5,5H' + (bb.width / 2 + 10).toString() + 'v' + (bb.height + 20).toString() + 'h-' + (bb.width + 20).toString() + 'z');
            };
            const tooltip = svg.append("g");

            var tt = function (c) {
                var m = d3.mouse(this);
                var tooltip_x = m[0] + margin.left;
                var w = parseFloat(tooltip.attr("w"));
                if (tooltip_x < w + 10)
                    tooltip_x = w + 10;
                if (tooltip_x + w / 2 + 10 > width)
                    tooltip_x = width - w / 2 + 10;
                tooltip
                    .attr("transform", 'translate(' + tooltip_x.toString() + ',' + (m[1] + margin.top).toString() + ')')
                    .call(callout, /*window.$(this).attr('name') + '\n' + */window.$(this).attr('xlabel') + '\n' + c.toString() + " " + measure);
            };
            var ttl = function () { tooltip.call(callout, null); };

            for (var i = 0; i < sec.length; i++) {
                svg.selectAll("#dots" + i + " circle").on("touchmove mousemove", tt);
                svg.selectAll("#dots" + i + " circle").on("touchend mouseleave", ttl);
                svg.selectAll("#dots_" + i + " circle").on("touchmove mousemove", tt);
                svg.selectAll("#dots_" + i + " circle").on("touchend mouseleave", ttl);
                svg.selectAll("#dots_empty_" + i + " circle").on("touchmove mousemove", tt);
                svg.selectAll("#dots_empty_" + i + " circle").on("touchend mouseleave", ttl);
                svg.selectAll("#dots_ic_" + i + " circle").on("touchmove mousemove", tt);
                svg.selectAll("#dots_ic_" + i + " circle").on("touchend mouseleave", ttl);
                svg.selectAll("#dots_nc_" + i + " circle").on("touchmove mousemove", tt);
                svg.selectAll("#dots_nc_" + i + " circle").on("touchend mouseleave", ttl);
            }

            var buttons = this.getChartButtons();
            var btnPoints = document.createElement("button");
            btnPoints.id = "btnPoints";
            btnPoints.innerHTML = '<i class="icon icon-askue_points"><svg class="svgicon-askue_points"><use xlink:href="/data/icons/svg#icon-askue_points"></use></svg></i>';
            btnPoints.style.cssText = "margin:2px; width:40px";
            btnPoints.classList.add("btn");
            btnPoints.classList.add("btn-primary");
            btnPoints.classList.add("btnchecked");
            btnPoints.title = "Скрыть точки";
            btnPoints.onclick = function () {
                if (btnPoints.classList.contains("btnchecked")) {
                    btnPoints.classList.remove("btnchecked");
                    btnPoints.title = "Показать точки";
                }
                else {
                    btnPoints.classList.add("btnchecked");
                    btnPoints.title = "Скрыть точки";
                }
                for (var n = 0; n < sec.length; n++) {
                    var dots = d3.select("#dots" + n);
                    var dots_ = d3.select("#dots_" + n);
                    display_ic(n);
                    display_nc(n);
                    display_empty(n);
                    if (sec[n] && btnPoints.classList.contains("btnchecked")) {
                        dots.style("opacity", "1");
                        dots_.style("opacity", "1");
                    }
                    if (!btnPoints.classList.contains("btnchecked")) {
                        dots.style("opacity", "0");
                        dots_.style("opacity", "0");
                    }
                }
                return false;
            };
            buttons.appendChild(btnPoints);

            chart_helper.addButtonIncreaseZoom(zoom, svg);
            chart_helper.addButtonReduceZoom(zoom, svg);
            chart_helper.addButtonResetZoom(zoom, svg);
            chart_helper.addButtonSave(args.fileName ?? 'график');
            if (args.autoResize)
                chart_helper.addButtonFullScreen(document.getElementById(args.idChart));

            for (var i = 0; i < sec.length; i++)
                if (!sec[i]) d3.select('#text' + i).dispatch('click');
        },

        loadDataSeries: function (sec, data, xdata, ydata, titles) {
            for (var j = 0; j < sec.length; j++) {
                var datai = [];
                for (var i = 0; i < xdata.length; i++) {
                    datai.push(ydata[j][i]);
                }
                data.series.push({ num: j, isScale: true, name: titles[j], values: datai });
            }
        }
    };
    return instance;
}();